var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-4 mt-2 sub"},[_vm._v(_vm._s(_vm.title))]),_c('router-link',{attrs:{"to":_vm.targetPath}},[_c('img',{staticStyle:{"width":"400px","max-width":"100%"},attrs:{"src":_vm.image}})]),_c('br'),_c('v-btn',{staticClass:"mt-2",attrs:{"to":_vm.targetPath,"color":"info"}},[_vm._v("Check it out!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }